import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { CadastroSidebar } from "@/components/cadastro/CadastroSidebar";
import Obras from "./cadastro/Obras";
import Clientes from "./cadastro/Clientes";
import UsuariosPermissoes from "./cadastro/UsuariosPermissoes";
import Materiais from "./cadastro/Materiais";
import Equipamentos from "./cadastro/Equipamentos";
import MaoDeObra from "./cadastro/MaoDeObra";
// Fornecedores e SetoresDisciplinas estão fora da v1 (ver CadastroSidebar).
// Os arquivos continuam em ./cadastro/ para a v2 — só não são importados nem
// roteados aqui. O catch-all abaixo manda as URLs antigas para /cadastro/obras.
const Cadastro = () => {
  return (
    <div className="flex min-h-screen">
      <CadastroSidebar />
      {/* min-w-0: sem isso o filho flex assume min-width:auto e a tabela larga
          estica o container, criando scroll horizontal na página inteira */}
      <div className="flex-1 min-w-0">
        <Routes>
          <Route path="" element={<Navigate to="obras" replace />} />
          <Route path="obras" element={<Obras />} />
          <Route path="clientes" element={<Clientes />} />
          <Route path="usuarios" element={<UsuariosPermissoes />} />
          <Route path="materiais" element={<Materiais />} />
          <Route path="equipamentos" element={<Equipamentos />} />
          <Route path="mao-de-obra" element={<MaoDeObra />} />
          <Route path="*" element={<Navigate to="obras" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default Cadastro;
